import { BACKEND_URL } from "../../../../services/Api";

const WorkTypeList = ({ loading, data, onEdit, onToggle }) => {
    return (
        <div className="admin-table-wrapper">
            <table className="admin-table">
                <thead>
                    <tr>
                        <th className="col-sr">Sr</th>
                        <th>Work Image</th>
                        <th>Work Type</th>
                        <th className="col-status">Status</th>
                        <th className="col-actions">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {loading && (
                        <tr>
                            <td colSpan="5" className="text-center">Loading...</td>
                        </tr>
                    )}

                    {!loading && data.length === 0 && (
                        <tr>
                            <td colSpan="5" className="text-center">
                                No Work Types Found
                            </td>
                        </tr>
                    )}

                    {!loading &&
                        data.map((d, i) => (
                            <tr key={d.id}>
                                <td className="col-sr">{i + 1}</td>
                                <td className="img-td">{d.workImageUrl ? (
                                    <img src={`${BACKEND_URL}${d.workImageUrl}`}
                                        alt="Work Type Image"
                                        style={{
                                            width: "60px",
                                            height: "60px",
                                            objectFit: "contain",
                                            // borderRadius: "4px",
                                            // border: "1px solid #d1d5db",
                                        }}
                                    />
                                ) : (
                                    <span style={{ color: "#9ca3af" }}>
                                        No Image
                                    </span>
                                )}
                                </td>
                                <td>
                                    {d.workTypeName}
                                </td>

                                <td className="col-status">
                                    <button className="admin-btn-small">
                                        {d.active ? "Active" : "Inactive"}
                                    </button>
                                </td>
                                <td className="col-actions">
                                    <div className="admin-action-edit">
                                        <span className="act-1 cursor-pointer" onClick={() => onEdit(d)}>
                                            Edit
                                        </span>
                                        {" / "}
                                        <span className="act-2 cursor-pointer" onClick={() => onToggle(d)}>
                                            {d.active ? "Deactivate" : "Activate"}
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    )
}

export default WorkTypeList;
